import API from 'api/api';
import * as actions from './actions';

/********************** PRIZES **********************/

export const getPrizes = () => dispatch => {
  dispatch( actions.setLoading( 'prizes', true ) );
  return API.get( `/rewards/prizes` )
  .then( ({ prizes, school_store }) => { 
    dispatch( actions.setPrizes( prizes ) );
    dispatch( actions.setStoreOpen( school_store ) );
    return prizes;
  });
}

export const createPrize = prize => dispatch => {
  return API.post( `/rewards/prizes`, prize )
  .then( prize => { 
    dispatch( actions.createPrize( prize ) ); 
    return prize;
  });
}

export const updatePrize = ( id, updates ) => dispatch => {
  return API.post( `/rewards/prizes?id=${id}`, updates )
  .then( prize => { 
    dispatch( actions.updatePrize( id, prize ) ); 
    return prize;
  });
}

export const deletePrize = ( id ) => dispatch => {
  console.log('Deleting prize with ID:', id);
  return API.post( `/rewards/prizes?action=delete&id=${id}` )
  .then( deleted_id => { 
    console.log('Prize deleted successfully, ID:', deleted_id);
    dispatch( actions.deletePrize( deleted_id ) ); 
    return deleted_id;
  })
  .catch( error => {
    console.error('Error deleting prize:', error);
    throw error;
  });
}

/********************** PRIZE TEMPLATES **********************/

export const getTemplates = () => dispatch => {
  dispatch( actions.setLoading( 'templates', true ) );
  return API.get( `/rewards/templates` )
  .then( templates => { 
    dispatch( actions.setTemplates( templates ) ); 
    return templates;
  });
}

export const createTemplate = template => dispatch => {
  return API.post( `/rewards/templates`, template )
  .then( template => { 
    dispatch( actions.createTemplate( template ) ); 
    return template;
  });
}

export const updateTemplate = ( id, updates ) => dispatch => {
  return API.post( `/rewards/templates?id=${id}`, updates )
  .then( template => { 
    dispatch( actions.updateTemplate( id, template ) ); 
    return template;
  });
}

/********************** STORE STATUS **********************/
export const setStoreOpen = ( school_store ) => dispatch => {
  return API.post( `/rewards/prizes?action=setStoreOpen`, { school_store } )
  .then( data => dispatch( actions.setStoreOpen( data.school_store ) ) );
}

/********************** NON STORE API OPERATIONS **********************/
// upload a prize image. does not deal with store
export const uploadImage = ( formData ) => dispatch => {
  return API.post( '/rewards/prizes?action=uploadImage', formData )
}

// Export updatePrizeLocally for optimistic UI
export const updatePrizeLocally = (id, updates) => dispatch => {
  dispatch(actions.updatePrizeLocally(id, updates));
};



// WEBPACK FOOTER //
// ./src/store/rewards/prizes/operations.js